import { render, staticRenderFns } from "./BaseSingleSelect.vue?vue&type=template&id=06e60c63&"
import script from "./BaseSingleSelect.vue?vue&type=script&lang=ts&"
export * from "./BaseSingleSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports